import styled from 'styled-components';
import { Div } from './StyledUtils';

export const StyledCentered = styled(Div)`
  position: sticky;
  left: 0;
  right: 0;
  z-index: 1;
  background-color: var(--color-background);
`;
